/**
 * Selectable room / look waypoints for Marble courses.
 * - Multi-room: fade + env cut (office-explore).
 * - Single-room look presets: jump camera target/FOV at the same eye (office-walk-poc).
 */
export type RoomWaypoint = {
  id: string;
  label: string;
  /** beat id to jump to (usually the hold look-around beat). */
  beatId: string;
  environmentId: string;
};

export function RoomWaypointNav({
  rooms,
  activeEnvironmentId,
  activeBeatId,
  disabled,
  label = "Go to",
  onSelect,
}: {
  rooms: RoomWaypoint[];
  activeEnvironmentId: string | null;
  /** When set, highlight by beat (same-room look presets share one env). */
  activeBeatId?: string | null;
  disabled?: boolean;
  label?: string;
  onSelect: (room: RoomWaypoint) => void;
}) {
  return (
    <nav className="room-wp" aria-label={label}>
      <div className="room-wp-label">{label}</div>
      <div className="room-wp-list">
        {rooms.map((r) => {
          const active = activeBeatId
            ? r.beatId === activeBeatId
            : r.environmentId === activeEnvironmentId;
          return (
            <button
              key={r.id}
              type="button"
              className={`room-wp-btn ${active ? "on" : ""}`}
              disabled={disabled || active}
              onClick={() => onSelect(r)}
            >
              {r.label}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
